import { render, staticRenderFns } from "./userRecord.vue?vue&type=template&id=49e31fc2&scoped=true&"
import script from "./userRecord.vue?vue&type=script&lang=js&"
export * from "./userRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e31fc2",
  null
  
)

export default component.exports